export enum EIntegrationType {
  GOOGLE = "google",
}

export enum EIntegrationStatus {
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
}

export interface IGoogleCallbackData {
  code: string;
  scope: string;
}

export interface IConnectIntegration {
  id: string;
  type: EIntegrationType;
}

export interface IIntegration {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  type: string;
  userId: string;
  expiredAt: string;
  status: EIntegrationStatus;
}

export interface ISpreadsheetConfig {
  name?: string;
  folderId?: string;
}

export interface ISheetConfigResponse {
  config: ISpreadsheetConfig;
  spreadsheetUrl: string | null;
}

export interface IUpdateSheetConfigRequest {
  name?: string | null;
  folderId?: string | null;
}

export interface IUpdateSheetConfigResponse {
  message: string;
  config: ISpreadsheetConfig;
}
